<template>
  <span>
    <span style="width: 50px; display: inline-block; text-align: center;">-</span>
    <span style="width: 50px; display: inline-block; text-align: center;">-</span>
    <span style="width: 50px; display: inline-block; text-align: center;">-</span>
    <span style="width: 50px; display: inline-block; text-align: center;">-</span>
    <span style="width: 50px; display: inline-block; text-align: center;">-</span>
  </span>
</template>
<script>
export default {
  name: 'EmptyNumbers'
}
</script>
